import type { CreateSaleSchema } from "@/api/schemas/sale.schema";
import { http } from "@/lib/http";
import { useToast } from "@/providers/toast.provider";
import type { SaleWithRelations } from "@/types/sale-with-relations";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useCreateSale() {
  const queryClient = useQueryClient();
  const { toaster } = useToast();

  return useMutation({
    mutationFn: async (data: CreateSaleSchema) => {
      const res = await http.post<SaleWithRelations>("/sales", data);
      return res.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sale", "me"] });
    },

    onError: (error) => {
      toaster(error?.message ?? "Algo deu errado!", "error");
    },
  });
}
